/* src/app/pages/amplify-auth/password-validity/password-validity.component.scss */
.password-validity-container {
  text-align: center;
  margin-top: 50px;
}
.buttons {
  margin-top: 20px;
}
.continue-button,
.change-password-button {
  padding: 10px 20px;
  margin: 0 10px;
  font-size: 16px;
  cursor: pointer;
}
.continue-button {
  background-color: #007bff;
  color: #fff;
  border: none;
}
.change-password-button {
  background-color: #007bff;
  color: #fff;
  border: none;
}
.continue-button:hover,
.change-password-button:hover {
  opacity: 0.8;
}
/*# sourceMappingURL=password-validity.component.css.map */
